import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api, app } from '@configs/routes.json';
import { ReactComponent as ResultIcon } from '@assets/images/results_default.svg';
import { IOrderTestReport } from '@models';
import './ResultCell.scss';

export enum ReportStatus {
  active = 'Active',
  obsolete = 'Obsolete',
}
interface IReportList {
  active: IOrderTestReport | undefined;
  updated: IOrderTestReport[];
  obsoleted: string[];
}
interface IResultIdCell {
  externalSubjectId: string;
  projectId: string | undefined;
  reports: IOrderTestReport[];
}

const ResultsCell: React.FC<IResultIdCell> = ({
  externalSubjectId,
  reports,
  projectId,
}) => {
  const [reportsList, setReportsList] =
    useState<IReportList | undefined>(undefined);
  const [activeUrl, setActiveUrl] = useState<string | undefined>(undefined);
  const { t } = useTranslation();

  useEffect(() => {
    let reportList: IReportList = {
      active: undefined,
      updated: [],
      obsoleted: [],
    };
    if (reports.length > 0) {
      //order reports by date first
      reports.sort((a, b) => +new Date(b.created) - +new Date(a.created));

      // separate the reports
      reports.forEach((report) => {
        if (report.status === ReportStatus.active) {
          const { orderTestId, documentType, name } = report;
          const url = `${api.samples.get
            .replace(':sampleId', orderTestId)
            .replace(':type', documentType)
            .replace(':name', name)}?projectid=${projectId}`;
          reportList.active = report;
          setActiveUrl(url);
        }
        if (report.status === ReportStatus.obsolete) {
          reportList.obsoleted.push(report.name);
        }
      });
      setReportsList(reportList);
    }
  }, []);

  const renderCell = () => {
    // if active report exist
    if (reportsList) {
      return (
        <div className='results-cell-container'>
          {reportsList.active ? (
            <div>
              <div className='results-active'>
                <a href={activeUrl} download className='primary'>
                  <ResultIcon className='poll-icon' title='result-icon' />
                  {reportsList.active?.name}
                </a>
              </div>
              {reportsList.active && reportsList.obsoleted.length > 0 ? (
                <div className='results-updated'>
                  {`(Updated from ${reportsList.obsoleted.join(
                    t('list_delimiter')
                  )})`}
                </div>
              ) : null}
            </div>
          ) : (
            <div>
              {reportsList.obsoleted.length > 0 ? (
                <div className='results-obsoleted'>
                  <span>{reportsList.obsoleted.join(t('list_delimiter'))}</span>
                  <div>(Obsoleted)</div>
                </div>
              ) : null}
              <div className='results-active'>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href={`${app.results}?externalSubjectId=${encodeURIComponent(
                    externalSubjectId
                  )}`}
                >
                  <span>{t('results_cell_findLatest')}</span>
                  <i className='fas fa-chevron-right'></i>
                </a>
              </div>
            </div>
          )}
        </div>
      );
    }
    // not active
    else {
      return null;
    }
  };

  return <td className='results-cell'>{renderCell()}</td>;
};

export default ResultsCell;
